import { operatorApiFetch } from './apiService';

const productCategoryService = {
  // 獲取分類列表（用於表格）
  getRecords: async (params = {}) => {
    const res = await operatorApiFetch('product_categories/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取所有分類 ID（用於篩選）
  getIds: async (params = {}) => {
    const res = await operatorApiFetch('product_categories/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取分類列表（用於下拉選單）
  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams(params);
    const res = await operatorApiFetch(`product_categories?${queryParams.toString()}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 獲取單個分類
  get: async (id) => {
    const res = await operatorApiFetch(`product_categories/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 創建分類
  create: async (data) => {
    const res = await operatorApiFetch('product_categories', {
      method: 'POST',
      body: { product_category: data }
    });
    return res.json();
  },

  // 更新分類
  update: async (id, data) => {
    const res = await operatorApiFetch(`product_categories/${id}`, {
      method: 'PUT',
      body: { product_category: data }
    });
    return res.json();
  },

  // 刪除分類
  delete: async (id) => {
    const res = await operatorApiFetch(`product_categories/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  }
};

export { productCategoryService };
export default productCategoryService;
